// extracted by mini-css-extract-plugin
export default {"twoColumns":"twoColumns___RlmU2"};